<div class="vzc-header">
  <div class="vzc-header__logo-container">
    <mat-icon
      svgIcon="ds-reveal-logo"
      class="vzc-header__reveal-logo"
      aria-hidden="false"
      i18n-aria-label="@@S_ACCOUNT_ACTIVATION_REVEAL_LOGO"
      aria-label="Reveal logo"
    ></mat-icon>
  </div>
</div>
